import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Api } from "@/api.config";
import { Spinner } from "@/common/Spinner";
import { LinkGen, QueryKeys } from "@/LinkGen";
import { AppPage } from "@/layout/AppLayout";
import styles from "./PageSubscription.module.css";

export const PageSubscriptionSuccess = () => {
  const navigate = useNavigate();

  const { data: profile } = useQuery({
    queryKey: QueryKeys.Profile(),
    queryFn: () => Api.Profile(),
    refetchInterval: 3000,
  });

  useEffect(() => {
    if (profile?.subscription) {
      navigate(LinkGen.Subscription(), { replace: true });
    }
  }, [profile, navigate]);

  return (
    <AppPage title="Activating Subscription">
      <div className={styles.success}>
        <Spinner />
        <p>Activating your subscription...</p>
      </div>
    </AppPage>
  );
};
